import { useMutation, useQuery } from '@tanstack/react-query'
import { getAccountAISettings, updateAccountAISettings, testAccountAPIKey } from './byokApi'

/**
 * Hook for managing BYOK AI settings
 * @param {string} accountID - Account ID
 */
export const useBYOK = (accountID) => {
    // Get current BYOK settings
    const {
        data: settings,
        refetch,
        isLoading,
        error,
    } = useQuery({
        queryKey: ['byokSettings', accountID],
        queryFn: () => getAccountAISettings(accountID),
        enabled: !!accountID,
    })

    // Update BYOK settings
    const { mutate: updateSettings, isPending: isUpdating } = useMutation({
        mutationFn: ({ aiProvider, aiApiKey }) =>
            updateAccountAISettings(accountID, aiProvider, aiApiKey),
        onSuccess: (data, variables) => {
            refetch()
            variables?.onSuccess?.(data)
        },
        onError: (error, variables) => {
            variables?.onError?.(error)
        },
    })

    // Test API key
    const { mutate: testKey, isPending: isTesting } = useMutation({
        mutationFn: ({ provider, apiKey }) => testAccountAPIKey(provider, apiKey),
    })

    return {
        settings: settings || { aiProvider: null, hasCustomKey: false },
        isLoading,
        error,
        updateSettings,
        isUpdating,
        testKey,
        isTesting,
        refetch,
    }
}
